<template>
    <div class="form-inline justify-content-between">
        <div>
            <span>{{agency.name}}</span>
        </div>
        <div>
            <button type="button" @click.prevent="visibleSettings = true" class="btn btn-primary btn-sm">Настройки</button>
            <button type="button" @click.prevent="visibleUsers = true" class="btn btn-primary btn-sm">Пользователи</button>
        </div>
        <el-dialog v-if="visibleSettings" :visible.sync="visibleSettings" @close="handlerCloseSettings" :title="'Настройки для ' + agency.name" :append-to-body="true" width="1200px">
            <AgencyForm @updated="handlerUpdated" :agency_id="agency.id" />
        </el-dialog>
        <el-dialog v-if="visibleUsers" :visible.sync="visibleUsers" :title="'Пользователи ' + agency.name" :append-to-body="true" width="800px">
            <AgencyUserList :agency_id="agency.id" />
        </el-dialog>
    </div>
</template>

<script>
import AgencyForm from "./AgencyForm.vue";
import AgencyUserList from "./AgencyUserList.vue";

export default {
    name: "AgencyManageListItem",
    components: {AgencyUserList, AgencyForm},
    props: ['agency'],
    data: () => ({
        isLoading: false,
        visibleSettings: false,
        visibleUsers: false,
    }),
    mounted() {

    },
    methods: {
        handlerCloseSettings() {

        },
        handlerUpdated(data) {
            this.$emit('updated', data);
        },
    }
}
</script>

<style scoped>

</style>
